import React from "react";
import about_img from "../assets/about_img.jpg";
import { Link } from "react-router-dom";

const AboutUs = () => {
  // const about_points = [
  //   "Explore how new technologies can enhance patient care and streamline nursing practices.",
  //   "Delve into personalized approaches to gynecology and obstetrics care.",
  //   "Address the importance of early detection and treatment of cancer.",
  //   "Discuss the latest developments in women's health, reproductive medicine, Neonatal care etc.",
  // ];

  return (
    <div className="flex flex-col md:flex-row gap-2 bg-pimary items-stretch justify-center p-4 md:px-12 md:py-4">
      <div className="flex mt-10 justify-center items-center md:w-[40%] h-full">
        <img
          src={about_img}
          alt="Dental Conference 2025"
          loading="lazy"
          className="h-[100%] w-[100%] object-cover rounded-2xl"
        />
      </div>

      <div className="flex flex-col w-full md:w-[65%] h-full justify-between p-4 md:p-6">
        <div>
          <h1 className="text-xl md:text-3xl font-bold my-2">
            <span className="text-one">Welcome to ICAN 2025</span>{" "}
            <span>– The Global Autism Summit & Neuropsychiatry Conference</span>
          </h1>
          <p className="text-base my-2">
            The International Conference on Autism & Neuropsychiatry, branded as
            ICAN 2025, stands at the forefront of innovation, advocacy, and
            collaboration in the fields of autism and brain science. This event is
            a key gathering among the most influential{" "}
            <Link
              className="text-accent font-bold"
              target="_blank"
              to="https://autism.helixconferences.com/"
            >
              2025 Autism Conferences
            </Link>{" "}
            and Upcoming Neurology Conferences 2025, attracting scientists,
            Clinicians, Therapists, Educators, and Neurodiversity advocates from
            across the Globe. Join us at this pivotal gathering of minds, where{" "}
            <strong className="text-accent">Global Neuroscience Events</strong> take a focused turn towards inclusive
            mental health solutions, early diagnosis, behavioral science, and
            Neurodivergent support.
          </p>
          <blockquote className="italic text-one my-2 border-l-4 border-one pl-4">
            "Be part of ICAN - 2025 Innovative Future In Autism & Neuropsychiatry."
          </blockquote>
        </div>

        <Link to="/about-ICAN" className="mt-auto">
          <button className="flex bg-one text-primary px-6 md:px-8 py-2 my-4 rounded-full text-sm md:text-base">
            Know More
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AboutUs;
